import { Share } from '@mui/icons-material';
import { Button, IconButton, useTheme } from '@mui/material';
import * as Preact from 'preact';
import * as ActionBar from './M_ActionBar';
import { isSmallScreen } from './domain/theme/breakpoints';
import { ArIcon, ShoppingIconBlack } from './icons';
// TODO: button selection states
export var Component = function (p) {
    var theme = useTheme();
    var isSmall = isSmallScreen(theme);
    return (Preact.h(ActionBar.Component, { sx: {
            position: 'absolute',
            top: '20px',
            right: '20px',
            zIndex: theme.zIndex.appBar,
        } },
        Preact.h(IconButton, { size: isSmall ? 'small' : 'large', color: "secondary", onClick: p.onShare, disabled: p.disableShare, "data-testid": "share-button" },
            Preact.h(Share, { sx: { fontSize: '24px' } })),
        p.onAr && isSmall && (Preact.h(IconButton, { size: "small", color: "secondary", onClick: p.onAr },
            Preact.h(ArIcon, { fontSize: "medium" }))),
        p.onAr && !isSmall && (Preact.h(Button, { startIcon: Preact.h(ArIcon, { fontSize: "medium" }), size: "large", color: "secondary", variant: "text", onClick: p.onAr }, p.arText)),
        !p.hideBasketPrice && (Preact.h(Button, { startIcon: Preact.h(ShoppingIconBlack, { fontSize: isSmall ? 'small' : 'medium' }), size: isSmall ? 'small' : 'large', color: "primary", variant: "contained", onClick: p.onCheckout, "data-testid": "add-to-basket-button", disabled: p.onCheckout === undefined }, p.basketPrice))));
};
Component.displayName = 'ActionBarFinalise';
